const CallToActionQuote = {
	el: {
		callToActionBlock: document.querySelectorAll<HTMLElement>(
			".call-to-action-quote-block",
		),
	},

	init() {
		if (this.el.callToActionBlock) {
			setTimeout(() => {
				this.positionElements();
			}, 100);

			window.addEventListener("resize", () => {
				this.positionElements();
			});
		}
	},

	positionElements() {
		this.el.callToActionBlock.forEach((block) => {
			const employeeImage = block.querySelector(".quote__image");

			if (employeeImage != null) {
				const imageHeight = employeeImage.clientHeight;
				const background = block.querySelector(
					".call-to-action-quote-block__background",
				);
				const quoteText = block.querySelector(".quote__text-container");
				const callToAction = block.querySelector(
					".call-to-action-quote-block__call-to-action",
				);
				//* background height is equal to the half of the employee image height and
				//* the height of the call to action component minus 127px
				let backgroundHeight =
					imageHeight / 2 + (callToAction.clientHeight - 127);

				if (window.innerWidth > 774) {
					//* if we are looking at desktop version the background height is equal to
					//* half of the employee height and half of the height of the call to action component
					backgroundHeight = imageHeight / 2 + callToAction.clientHeight / 2;

					//* positioning the quote text accordion to the height of the employee image
					quoteText.setAttribute(
						"style",
						"margin-top:" + imageHeight / 2 + "px",
					);
				} else {
					//* adding margin to have poper spacing in mobile
					quoteText.setAttribute("style", "margin-top: 85px");
				}

				//* positioning the background according to the height of the employee image
				//* adding the calculated background height into a css calc funtion so it has the proper height
				background.setAttribute(
					"style",
					"top:" +
						imageHeight / 2 +
						"px; height: calc(100% - " +
						backgroundHeight +
						"px)",
				);
			}
		});
	},
};

export default CallToActionQuote;
